import * as React from 'react';
import { Tile } from '../../../models/Mahjong';
import { Hand } from '../../mahjong/components/Hand';

export function TileSetDisplay(): JSX.Element {
    const winds = ['east', 'south', 'west', 'north'];
    const dragons = ['white', 'green', 'red'];

    const honorTiles: Tile[] = [];

    const generateSuit = (type: 'man' | 'pin' | 'sou') => {
        const tiles: Tile[] = [];
        for (let i = 1; i <= 9; i++) {
            tiles.push({
                id: `${type}-${i}`,
                type: type,
                value: i,
                isRed: false
            } as Tile);
        }
        return tiles;
    };

    // Generate Wind Tiles
    winds.forEach(wind => {
        honorTiles.push({
            id: `wind-${wind}`,
            type: 'wind',
            value: wind as any,
            isRed: false
        } as Tile);
    });

    // Generate Dragon Tiles
    dragons.forEach(dragon => {
        honorTiles.push({
            id: `dragon-${dragon}`,
            type: 'dragon',
            value: dragon as any,
            isRed: false
        } as Tile);
    });

    return (
        <div className="flex-vertical align-center gap-2 ma-2 flex-fill">
            <h2 className="white-text">Full Tile Set</h2>
            <div className="flex-vertical gap-2" style={{ width: '100%' }}>
                <Hand tiles={generateSuit('man')} />
                <Hand tiles={generateSuit('pin')} />
                <Hand tiles={generateSuit('sou')} />
                <Hand tiles={honorTiles} />
            </div>
        </div>
    );
}
